module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/brescia.47fd4bff6a4fb3e5600284e55cc9ad41.jpg";